import { push } from 'react-router-redux';
import { ApiService } from 'services';
import { clearDefaultForm } from 'actions';
import { handleException } from 'actions/exceptions';
import { HANDLE_UNCAUGHT_EXCEPTION } from 'actions/exceptions/handleUncaughtException';

export const ADD_FORM_REQUEST = 'ADD_FORM_REQUEST';
export const ADD_FORM_SUCCESS = 'ADD_FORM_SUCCESS';
export const ADD_FORM_FAILURE = 'ADD_FORM_FAILURE';

function request(formType) {
  return {
    type: ADD_FORM_REQUEST,
    isAddingForm: formType
  };
}

function receive() {
  return {
    type: ADD_FORM_SUCCESS
  };
}

function reject(error) {
  return {
    type: HANDLE_UNCAUGHT_EXCEPTION,
    code: error.code,
    message: error.message
  };
}

export function addOnlineForm(formTypeInfo, accountId) {
  const { formType } = formTypeInfo;
  const postData = {
    isOnline: true,
    accountId,
    formType
  };

  return (dispatch) => {
    if (!formTypeInfo.canPrepopulate) {
      return dispatch(push('/insufficient-information'));
    }

    dispatch(request(formType));

    const promise = () => ApiService
      .addForm(postData)
      .then((response) => {
        if (response.data && response.data.success && response.data.formId > 0) {
          const formUrl = `/forms/${ formType }/${ response.data.formId }`;
          dispatch(receive());
          dispatch(clearDefaultForm(formUrl));
          return dispatch(push(formUrl));
        }

        dispatch({ type: ADD_FORM_FAILURE });
        if (response.data && response.data.error) {
          return dispatch(reject(response.data.error));
        }

        return dispatch(reject({
          code: '-9999',
          message: 'Sorry, there was an unexpected error communicating with our servers'
        }));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch({ type: ADD_FORM_FAILURE });
          if (error.response.status !== 403) {
            dispatch(handleException(error, reject));
          }
        }
      });

    return promise();
  };
}
